import { Link } from "react-router-dom"
import "./item1.css"

export function Item1() {
    return (
        <div className="slider-item item1 d-flex">
            <div className="w-50 d-flex cntr">
                <div className="d-flex flex-column justify-content-center gap-3">
                    <div className="d-flex align-items-center gap-3">
                        <div className="apple-logo"></div>
                        <p className="my-auto">iPhone 14 Series</p>
                    </div>
                    <div className="item1-heading">
                        Up to 10%<br />
                        off Voucher
                    </div>
                    <div className="d-flex">
                        <Link to="/shop" className="d-flex align-items-center">
                            <span className="pb-1">Shop Now</span>
                            <div className="cta-btn-arrow ms-2"></div>
                        </Link>
                        
                    </div>
                </div>
                
            </div>
            <div className="w-50 iphone-picture">

            </div>
        </div>
    )
}